import styled from 'styled-components';

const StyledNumbersWrap = styled.div`
  position: relative;
  padding: 0 64px;
  padding-bottom: ${ props => props.newHome ? `${props.theme.components_spacing_desk.xlarge}px` : 0};
  margin-bottom: ${ props => props.newHome ? `${props.theme.components_spacing_desk.xlarge}px` : 0};
  background-color: ${ props => props.newHome ? '#000' : 'trasparent'};
  color: ${ props => props.newHome ? '#fff' : 'inherit'};
  h4, h6{
    padding-bottom: ${props => props.theme.components_spacing_desk.large}px;
  }
  .row--single .number--cell-flex-text{
    width: 75%;
    margin: 0 auto;
  }
  @media screen and (max-width: 1439px){
    padding: 0 40px ${ props => props.newHome ? `${props.theme.components_spacing_tablet.xlarge}px` : 0};
    margin-bottom: ${ props => props.newHome ? `${props.theme.components_spacing_tablet.xlarge}px` : 0};
    h4, h6{
      padding-bottom: ${props => props.theme.components_spacing_tablet.large}px;
    }
  }
  
  @media screen and (max-width: 767px){
    padding: 0;
    padding-bottom: ${ props => props.newHome ? `${props.theme.components_spacing_mobile.xlarge}px` : 0};
    margin-bottom: ${ props => props.newHome ? `${props.theme.components_spacing_mobile.xlarge}px` : 0};
    .row--single .number--cell-flex-text{
      position: relative;
      width: 100%;
    }
    h4, h6{
      padding-left: 24px;
      padding-bottom: ${props => props.theme.components_spacing_mobile.large}px;
    }
  }
  
`;

export {
  StyledNumbersWrap,
};

